import { render, staticRenderFns } from "./VesselDashboard.vue?vue&type=template&id=0a6f57c6&scoped=true"
import script from "./VesselDashboard.vue?vue&type=script&lang=js"
export * from "./VesselDashboard.vue?vue&type=script&lang=js"
import style0 from "./VesselDashboard.vue?vue&type=style&index=0&id=0a6f57c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6f57c6",
  null
  
)

export default component.exports